module.exports = __webpack_public_path__ + "img/75-r.f36d7320.png";